import React, {useEffect} from "react";
import {Link, Navigate} from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import {Loading} from '../custom/LoadingComponent'
import UserFullRenderer from './UserFullRendererComponent';

function UserNew(props) {
    console.log('___UserNew___');

    useEffect(() => {
        props.loadComponentData();
    }, []);

    const user = {
        generalSection: {
            clientId: props.client.id,
            clientType: props.client.generalSection.clientType
        }
    }

    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.mostRecentUserId != null) {
        return(
            <Navigate to={`/users/${props.mostRecentUserId}`} replace />
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/users'>Utilizatori</Link>
                            <Typography color="text.primary">Adauga Utilizator</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>Utilizator Nou - {props.client.generalSection.clientName}</h3>
                    </Box>
                    <hr/>
    
                    <UserFullRenderer 
                        user={user} 
                        client={props.client}
                        saveUser={props.postUser} 
                        employers={props.employers}
                        worksites={props.worksites}    
                    />
                </Stack>

            </Box>
            </Container>
        );
    }

}

export default UserNew;